(function () {
  if (window.__dtc3ImageTextStoryLoaded) return;
  window.__dtc3ImageTextStoryLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 900px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isReducedMotion() {
    return reducedMotionQuery.matches;
  }

  function setFallbackState(media, shouldShow) {
    const trigger = media.querySelector('[data-dtc3-story-video-play]');
    media.toggleAttribute('data-dtc3-video-autoplay-failed', shouldShow);
    if (trigger) {
      trigger.hidden = !shouldShow;
    }
  }

  function syncInlineVideo(media) {
    const video = media.querySelector('[data-dtc3-story-inline-video]');
    if (!video) return;

    if (!mobileQuery.matches) {
      setFallbackState(media, false);
      video.muted = true;
      video.playsInline = true;
      return;
    }

    if (isReducedMotion()) {
      video.pause();
      setFallbackState(media, true);
      return;
    }

    video.muted = true;
    video.playsInline = true;
    setFallbackState(media, false);

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        setFallbackState(media, true);
      });
    }
  }

  function initStoryVideos(root) {
    if (root.dataset.dtc3StoryVideoInitialized === 'true') return;

    const mediaItems = Array.from(root.querySelectorAll('.dtc3-story-item__media--video'));
    if (!mediaItems.length) return;

    root.dataset.dtc3StoryVideoInitialized = 'true';

    function updateInlineVideos() {
      mediaItems.forEach(syncInlineVideo);
    }

    mediaItems.forEach((media) => {
      const playButton = media.querySelector('[data-dtc3-story-video-play]');
      const video = media.querySelector('[data-dtc3-story-inline-video]');
      if (!playButton || !video) return;

      playButton.addEventListener('click', () => {
        video.muted = true;
        video.playsInline = true;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => setFallbackState(media, false))
            .catch(() => setFallbackState(media, true));
        }
      });
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateInlineVideos);
      reducedMotionQuery.addEventListener('change', updateInlineVideos);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(updateInlineVideos);
      reducedMotionQuery.addListener(updateInlineVideos);
    }

    updateInlineVideos();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-dtc3-story]').forEach(initStoryVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
